import React from "react";
import PropTypes from "prop-types";
import { AskAnExpertAlert } from "./AskAnExpertAlert";

export const AskAnExpertInputField = props => {

  const {
    autoFocus,
    label,
    name,
    value,
    type,
    onChange,
    placeholder,
    maxLength = 80,
    isRequired = false,
    error = null
  } = props;

  if (isRequired === true) {
    return (
      <div className="form-group">
        <label>{label} <span className="color-red">*</span></label>
        <input
          autoFocus={autoFocus}
          type={type}
          className="form-control"
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          maxLength={maxLength}
          required={true}
        />
        {error !== null ? (
          <AskAnExpertAlert message={error} />
        ) : null}
      </div>
    );
  } else {
    return (
      <div className="form-group">
        <label>{label}</label>
        <input
          autoFocus={autoFocus}
          type="text"
          className="form-control"
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          maxLength={maxLength}
        />
        {error !== null ? (
          <AskAnExpertAlert message={error} />
        ) : null}
      </div>
    );
  }
};

AskAnExpertInputField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  isRequired: PropTypes.bool,
  error: PropTypes.string
};



// WEBPACK FOOTER //
// src/client/components/site/features/askanexpert/form/AskAnExpertInputField.js